module.exports = __webpack_public_path__ + "static/media/development-graphic-soon.efc374a7.png";